module.exports = __webpack_public_path__ + "static/tools-button-generator-3d3570d4a6e7b97c1f11f8df290e4e26.svg";